// convention for constants is
// [App_Name]_[Action]
var GraphicSourceConstants: IGraphicSourceConstants = {
    GRAPHIC_SOURCE_ADD: 'GRAPHIC_SOURCE_ADD',
    GRAPHIC_SOURCE_UPDATE: 'GRAPHIC_SOURCE_UPDATE',
    GRAPHIC_SOURCE_EDIT: 'GRAPHIC_SOURCE_EDIT',
    GRAPHIC_SOURCE_INVALID_ADD: 'GRAPHIC_SOURCE_INVALID_ADD',
    GRAPHIC_SOURCES: 'GRAPHIC_SOURCES',
    GRAPHIC_SOURCE_FINISH_EDIT: 'GRAPHIC_SOURCE_FINISH_EDIT',
    GRAPHIC_SOURCE_MODAL_CLOSE: 'GRAPHIC_SOURCE_MODAL_CLOSE',
    GRAPHIC_SOURCE_UPDATE_OBJECT: 'GRAPHIC_SOURCE_UPDATE_OBJECT',
} as const;

export default GraphicSourceConstants;
